import { render, staticRenderFns } from "./featured-product.vue?vue&type=template&id=25dee27e&"
import script from "./featured-product.vue?vue&type=script&lang=js&"
export * from "./featured-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports